module.exports = __webpack_public_path__ + "img/hotel-20.c93a0739.jpeg";